import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

const BarChart = ({ data, name }) => {
    // Calculate total for percentage
    const total = data?.reduce((sum, item) => sum + (item?.hits || 0), 0) || 1;

    const options = {
        chart: {
            type: 'bar',
        },
        title: {
            text: '',
        },
        xAxis: {
            categories: data?.map(item => item?.[name]),
            title: {
                text: name,
            },
        },
        yAxis: {
            min: 0,
            title: {
                text: name,
                align: 'high',
            },
            labels: {
                overflow: 'justify',
            },
        },
        tooltip: {
            formatter: function() {
                const percentage = (this.y / total * 100).toFixed(1);
                return `<b>${this.x}</b><br/>${this.y} Visits (${percentage}%)`;
            },
        },
        plotOptions: {
            bar: {
                dataLabels: {
                    enabled: true,
                    formatter: function() {
                        const percentage = (this.y / total * 100);
                        // Only show label if percentage is >= 10%
                        if (percentage >= 10) {
                            return `${percentage.toFixed(1)}%`;
                        }
                        return null; // Hide label for < 10%
                    },
                },
            },
        },
        legend: {
            enabled: false,
        },
        credits: {
            enabled: false,
        },
        series: [
            {
                name: name,
                data: data?.map(item => item?.hits),
                color: '#701540',
            },
        ],
    };

    return (
        <>
            <HighchartsReact highcharts={Highcharts} options={options} />
        </>
    );
};

export default BarChart;
